import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import PrebuiltBetAvantgarde from 'modules/prebuilt-bets/prebuilt-bet/view/avantgarde/index.js';
import { useSameMarketSubHeader } from 'modules/prebuilt-bets/prebuilt-bet/hooks/index.js';

const { PREBUILT_ACCA } = MojitoServices.Analytics.types.SELECTION_TYPE;
const { FlexPane, Text, Image } = MojitoPresentation.Components;
const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;
const AnalyticsContextBuilder = MojitoCore.Presentation.AnalyticsContext.ContextBuilder;
const analyticsContext = new AnalyticsContextBuilder().withAnalyticsPath(PREBUILT_ACCA).build();

const Header = ({ config, title, stringResolver }) => (
    <FlexPane config={config.headerSection} class="ta-PrebuiltAccaHeader">
        <FlexPane config={config.headerContainer}>
            <FlexPane config={config.titleContainer} class="ta-titleContainer">
                {config.showTitleIcon && (
                    <Image config={config.titleIcon} class="ta-titleIcon" alt="" />
                )}
                {Boolean(title) && (
                    <Text config={config.promotionText} class="ta-promotionText">
                        {title}
                    </Text>
                )}
            </FlexPane>
            {config.showBadge && (
                <FlexPane config={config.badgeContainer} class="ta-badgeContainer">
                    <Text config={config.badge} class="ta-badge">
                        {stringResolver.resolveString('$PREBUILT_ACCA.BADGE')}
                    </Text>
                </FlexPane>
            )}
        </FlexPane>
    </FlexPane>
);

const PrebuiltAccaAvantgarde = props => {
    const {
        mojitoTools: { config, stringResolver },
        market,
        event,
        promotionText,
        onEventClick,
        shouldRequestData,
    } = props;

    const { subHeader } = useSameMarketSubHeader(market?.preBuiltBetBuilderParts);

    return (
        <AnalyticsContextExtender value={analyticsContext} pathSeparator={'_'} pathReverse={true}>
            <PrebuiltBetAvantgarde
                config={config.view}
                market={market}
                event={event}
                showMarketName={!subHeader}
                onEventClick={onEventClick}
                shouldRequestData={shouldRequestData}
                class={'ta-PrebuiltAcca'}
            >
                {config.view.showCardHeader && (
                    <Header
                        config={config}
                        title={promotionText || subHeader}
                        stringResolver={stringResolver}
                    />
                )}
            </PrebuiltBetAvantgarde>
        </AnalyticsContextExtender>
    );
};

export default PrebuiltAccaAvantgarde;
